import { render, staticRenderFns } from "./TopRatedItems.vue?vue&type=template&id=303ed3b9&scoped=true"
import script from "./TopRatedItems.vue?vue&type=script&lang=js"
export * from "./TopRatedItems.vue?vue&type=script&lang=js"
import style0 from "./TopRatedItems.vue?vue&type=style&index=0&id=303ed3b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303ed3b9",
  null
  
)

export default component.exports